<div class="login-wrapper" fxLayout="row" fxLayoutAlign="center center">
  <mat-card class="box">
    <mat-card-header>
      <mat-card-title>Cadastrar</mat-card-title>
    </mat-card-header>
    <form class="example-form">
      <mat-card-content>
        <mat-form-field class="example-full-width">
          <input
            matInput
            placeholder="Usuário"
            [(ngModel)]="login.name"
            required
          />
        </mat-form-field>
        <mat-form-field class="example-full-width">
          <input
            matInput
            placeholder="Email"
            [(ngModel)]="login.email"
            required
          />
        </mat-form-field>
        <mat-form-field class="example-full-width">
          <input
            matInput
            placeholder="Senha"
            [(ngModel)]="login.password"
            required
          />
        </mat-form-field>
        <!-- <mat-form-field class="example-full-width">
          <mat-label>Choose a role...</mat-label>
          <mat-select>
            <mat-option [value]="roles" *ngFor="let roles of Roles"
              >{{ roles }}
            </mat-option>
          </mat-select>
        </mat-form-field> -->
      </mat-card-content>
      <button mat-stroked-button color="accent" class="btn-block">
        Cadastrar
      </button>
    </form>
  </mat-card>
</div>
